export const breadcrumb = {
  title: 'Predictive Dialer',
  trunk: {
    index: ''
  }
};
